"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.historyInitialized = exports.historyChanged = exports.routerUrlPushed = exports.HistoryActionType = void 0;
const base_1 = require("@hum/common/src/ducks/actions/base");
var HistoryActionType;
(function (HistoryActionType) {
    HistoryActionType["ROUTER_URL_PUSHED"] = "ROUTER_URL_PUSHED";
    HistoryActionType["HISTORY_CHANGED"] = "HISTORY_CHANGED";
    HistoryActionType["HISTORY_INITIALIZED"] = "HISTORY_INITIALIZED";
})(HistoryActionType = exports.HistoryActionType || (exports.HistoryActionType = {}));
exports.routerUrlPushed = (0, base_1.actionCreator)(HistoryActionType.ROUTER_URL_PUSHED);
exports.historyChanged = (0, base_1.actionCreator)(HistoryActionType.HISTORY_CHANGED);
exports.historyInitialized = (0, base_1.actionCreator)(HistoryActionType.HISTORY_INITIALIZED);
//# sourceMappingURL=history.js.map